import * as ex from "excalibur";

export function getTrait<T extends ex.IActorTrait>(actor: ex.Actor, type: {new(...args:any[]):T}):T {
    return actor.traits.filter(t => t instanceof type)[0] as T;
}

/**
 * Wraps a value such that it min < val <= max.
 */
export function wrap(val: number, min: number, max: number) {
    let range = max - min;
    while (val < min) {
        val += range;
    }
    while (val >= max) {
        val -= range;
    }
    return val;
}

